import { createContext, useContext, useState } from "react";

export const GroupSearchContext = createContext(null);
export function useGroupSearch() {
  const shared = useContext(GroupSearchContext);
  const local = useState("");
  return shared || local;
}
